export default __webpack_public_path__ + "static/media/Scaling_Product_Teams_When_Going_Remote_The_Product_People.75631459.jpg";